// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffportal/v1/report_service.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import { ReportService } from "./report_service_pb";

/**
 * @generated from rpc bffportal.v1.ReportService.ListOrganizationDealReports
 */
export const listOrganizationDealReports = ReportService.method.listOrganizationDealReports;

/**
 * @generated from rpc bffportal.v1.ReportService.ListOrganizationDealPerFrame
 */
export const listOrganizationDealPerFrame = ReportService.method.listOrganizationDealPerFrame;

/**
 * @generated from rpc bffportal.v1.ReportService.ListOrganizationMarginReports
 */
export const listOrganizationMarginReports = ReportService.method.listOrganizationMarginReports;
